import HelpInfo from './HelpInfo';

export default HelpInfo;
